var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 24,
    viewBox: "0 0 56 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_210_132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.6555 7.5C32.2941 7.5 34.4333 9.51106 34.4333 11.9954V11.9982C34.4333 14.4825 32.2941 16.4964 29.6555 16.4964C27.0167 16.4964 24.8776 14.4825 24.8776 11.9982V11.9954C24.8776 9.51106 27.0167 7.5 29.6555 7.5Z",
    fill: "#F47216"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1521 7.55798C22.9057 7.55798 23.5377 7.71022 24.3072 8.07738V10.0178C23.5785 9.34721 22.9464 9.06653 22.1105 9.06653C20.4674 9.06653 19.1755 10.3471 19.1755 11.9706C19.1755 13.6827 20.4276 14.887 22.1919 14.887C22.9862 14.887 23.6065 14.6209 24.3072 13.9611V15.9026C23.5104 16.2558 22.8648 16.3951 22.1105 16.3951C19.443 16.3951 17.3702 14.4679 17.3702 11.9826C17.3701 9.52401 19.4981 7.55798 22.1521 7.55798Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8697 7.61133C14.8544 7.61133 15.7553 7.92868 16.5086 8.54897L15.5919 9.67884C15.1356 9.19732 14.704 8.99425 14.1793 8.99425C13.4242 8.99425 12.8744 9.39893 12.8744 9.93138C12.8744 10.388 13.1829 10.6297 14.2342 10.9959C16.2268 11.6819 16.8174 12.2902 16.8174 13.6335C16.8174 15.2704 15.5402 16.4099 13.7199 16.4099C12.3868 16.4099 11.4177 15.9157 10.6106 14.8005L11.7422 13.7744C12.1456 14.5086 12.8187 14.9021 13.6543 14.9021C14.4358 14.9021 15.0144 14.3946 15.0144 13.7095C15.0144 13.3544 14.839 13.05 14.4892 12.8346C14.313 12.7327 13.964 12.5807 13.2782 12.3531C11.6328 11.7955 11.0684 11.1994 11.0684 10.0345C11.0683 8.65063 12.2806 7.61133 13.8697 7.61133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8884 7.75891H35.8019L38.197 13.4383L40.6232 7.75891H42.5222L38.6422 16.4314H37.6995L33.8884 7.75891Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.19895 7.77185H9.95082V16.2274H8.19895V7.77185Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3142 7.77185H48.2824V9.20458H45.0649V11.0814H48.1639V12.5134H45.0649V14.7959H48.2824V16.2274H43.3142V7.77185Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1728 12.6653C54.4922 12.4124 55.2183 11.5628 55.2183 10.2683C55.2183 8.68518 54.0604 7.77185 52.04 7.77185H49.4427V16.2274H51.1924V12.8305H51.421L53.8457 16.2273H56L53.1728 12.6653ZM51.7043 11.6643H51.1924V9.1036H51.7319C52.8228 9.1036 53.4158 9.53421 53.4158 10.3571C53.416 11.207 52.823 11.6643 51.7043 11.6643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.57132 7.77258H1.90735e-05V16.2281H2.55793C3.91791 16.2281 4.90033 15.926 5.7624 15.252C6.78704 14.4538 7.39283 13.2506 7.39283 12.0063C7.39291 9.51089 5.41239 7.77258 2.57132 7.77258ZM4.61794 14.1246C4.0675 14.5924 3.35255 14.7966 2.22071 14.7966H1.75044V9.20531H2.22062C3.35246 9.20531 4.03919 9.39618 4.61786 9.88914C5.22373 10.3971 5.58816 11.184 5.58816 11.9942C5.58825 12.8055 5.22373 13.6167 4.61794 14.1246Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_210_132"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.ed8e2568.svg";
export { ForwardRef as ReactComponent };